import { render, staticRenderFns } from "./CollapseOnClick.vue?vue&type=template&id=6866ef32"
import script from "./CollapseOnClick.vue?vue&type=script&lang=js"
export * from "./CollapseOnClick.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports